import { useCallback, useState } from 'react'
import { useResponsive } from './useResponsive'

export const useCharacterInteraction = () => {
    const { isMobile, hasTouch } = useResponsive()

    // 统一状态管理 - 兼容桌面端的hoveredCharacter和移动端的activeCharacter
    const [activeCharacter, setActiveCharacter] = useState(null)

    // 使用 useCallback 优化，避免不必要的重渲染
    const handleCharacterInteraction = useCallback((characterId, action = 'toggle') => {
        if (isMobile || hasTouch) {
            // 移动端逻辑：点击切换
            if (action === 'click' || action === 'toggle') {
                setActiveCharacter(prev => prev === characterId ? null : characterId)
            }
        } else {
            // 桌面端逻辑：hover行为
            if (action === 'enter' || action === 'hover') {
                setActiveCharacter(characterId)
            } else if (action === 'leave') {
                setActiveCharacter(null)
            }
        }
    }, [isMobile, hasTouch])

    // 检查某个角色是否处于激活状态
    const isCharacterActive = useCallback((characterId) => {
        return activeCharacter === characterId
    }, [activeCharacter])

    // 重置所有状态
    const resetInteraction = useCallback(() => {
        setActiveCharacter(null)
    }, [])

    return {
        activeCharacter,
        isCharacterActive,
        handleCharacterInteraction,
        resetInteraction,
        isMobile,
        hasTouch,
        // 为了保持向后兼容，提供旧的命名
        hoveredCharacter: activeCharacter,
        setHoveredCharacter: setActiveCharacter
    }
}